<template>
  <AuthBox>
    <h1 class="auth-title">Choose a role to sign up</h1>
    <div class="auth-subtitle mb-6">Before you sign up, you must choose a role first</div>
    <div class="d-flex justify-center">
      <svg-icon icon="student_signup" class="mb-6" width="250" height="100" />
    </div>
    <div class="d-flex justify-center">
      <v-btn color="primary btn-primary-custom mb-6" :to="{ name: 'AuthRegisterStudent' }" style="text-decoration: none;">Parent</v-btn>
    </div>
    <span class="dont-have-an-accoun">
      {{ $t('content.signin_1') }}
      <router-link :to="{ name: 'AuthLogin' }" style="text-decoration: none;">
        {{ $t('content.signin') }}
      </router-link></span
    >
  </AuthBox>
</template>

<script>
import { mapGetters } from 'vuex';
import { required, minLength, sameAs } from 'vuelidate/lib/validators';
import { hasNumber, hasSpecialChar, hasUppercase } from '@/validators/shared';
import AuthBox from '@/components/base/AuthBox';

export default {
  name: 'AuthChangePassword',
  components: {
    AuthBox
    // FormGroup
  },
  computed: {
    ...mapGetters({
      user: 'Auth/user'
    })
  },
  layout: 'empty',
  validations: {
    form: {
      pass1: { required, minLength: minLength(6), hasNumber, hasUppercase, hasSpecialChar },
      pass2: { required, sameAsPassword: sameAs('pass1') }
    }
  },
  data: () => ({
    form: {
      pass1: '',
      pass2: ''
    },
    loading: false,
    showPassword: false,
    showPassword2: false
  }),
  methods: {},
  created() {
    this.$store.commit('Auth/SET_GOOGLE_AUTH_CLEAR');
  }
};
</script>

<style lang="scss" scoped>
.dont-have-an-accoun {
  color: #acacac;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.forgot {
  color: #ce8800;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
</style>
